import { useEffect,useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

export default function CandidateLogin(){

    const { id } = useParams();
    const [data, setData]=useState([]);

    function getData(){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/course/open/getCourses`)
        .then(result=>setData(result.data))
        .catch(err=>console.log(err));
    }
    useEffect(()=>getData(),[]);

    function submitHandler(e){
        e.preventDefault(); 

        const obj = new FormData(e.target);
        const objdata = Object.fromEntries(obj.entries()); 
        axios.get(`${process.env.REACT_APP_BASE_URL}api/plan/open/verifyPasskey/`+objdata.passkey)
        .then(result=>{
            if(result.data===true){
                localStorage.setItem("fullname",objdata.fullname);
                localStorage.setItem("passkey",objdata.passkey);
                localStorage.setItem("courseId",objdata.course);
                localStorage.setItem("courseName",e.target.elements[2].options[e.target.elements[2].selectedIndex].text);
                window.location.href="/quiz";
            }else{
                alert("Invalid passkey!");
            }
        }).catch(err=>console.log(err)); 
    }
    
    return(<>
      <div className="login-container container">
            <div className="text-center">
                <h2>Quiz Portal!</h2>
                <hr />
            </div>
            <br />
            <div className="form">
                <form onSubmit={submitHandler}>
                    <div>
                        <label htmlFor="fullname">Fullname:</label>
                        <input type="text" className="form-control" name="fullname" required/>
                    </div>
                    <div>
                        <label htmlFor="passkey">Passkey:</label>
                        <input type="text" className="form-control" name="passkey" required/> 
                    </div>
                    <div>
                        <select name="course" className="form-select" hidden>
                          {data.map((course)=>
                            <option value={course.id} selected={course.id==id}>{course.name}</option>
                          )}
                        </select>
                    </div>
                    <br />
                    <div>
                        <button className="btn btn-color form-control" type="submit">Enter</button>
                    </div>
                     <br />
                    <div className="text-center">
                        <a href="/" className="text-decoration-none text-muted">
                        &larr; Return to Home
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </>);
}